import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "content-shape condensed container pt-4"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("Sign up");

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" By creating an account, you agree to the ");

var _hoisted_4 = /*#__PURE__*/_createTextVNode("Terms of Service");

var _hoisted_5 = /*#__PURE__*/_createTextVNode(" and ");

var _hoisted_6 = /*#__PURE__*/_createTextVNode("Privacy Policy");

var _hoisted_7 = /*#__PURE__*/_createTextVNode(". ");

var _hoisted_8 = {
  key: 0,
  class: "mb-5"
};
var _hoisted_9 = {
  class: "mt-3"
};

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" Create account ");

var _hoisted_11 = /*#__PURE__*/_createTextVNode(" Already have an account? ");

var _hoisted_12 = /*#__PURE__*/_createTextVNode("Sign in");

import { ref, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import VueTurnstile from "vue-turnstile";
import { useUserStore } from "@/store/user";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import { UserModel, UserValidator } from "@/schemes/user";
import { handleError } from "@/utils/errors";
import Link from "@/components/utils/Link.vue";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var router = useRouter();
    var route = useRoute();
    var userStore = useUserStore();
    var turnstileSiteKey = process.env.VUE_APP_TURNSTILE_SITEKEY;
    var LoaderState = LoaderStateEnum;
    var loaders = reactive({
      register: LoaderStateEnum.Idle
    });
    var captcha = ref("");
    var errors = reactive({});
    var model = reactive(_objectSpread({}, UserModel));
    var rules = UserValidator;
    var form = ref(null);

    var submit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var next;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (form.value) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return form.value.validate();

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", false);

              case 10:
                loaders.register = LoaderStateEnum.Loading;

                if (!(turnstileSiteKey && !captcha.value)) {
                  _context.next = 15;
                  break;
                }

                errors.register = "The captcha is invalid, please validate it.";
                loaders.register = LoaderStateEnum.Failed;
                return _context.abrupt("return");

              case 15:
                _context.prev = 15;
                _context.next = 18;
                return userStore.register(_objectSpread(_objectSpread({}, model), {}, {
                  captcha: captcha.value
                }));

              case 18:
                next = typeof route.query.to === "string" ? route.query.to : {
                  name: "Home"
                };
                _context.next = 21;
                return router.push(next);

              case 21:
                _context.next = 29;
                break;

              case 23:
                _context.prev = 23;
                _context.t1 = _context["catch"](15);
                _context.next = 27;
                return handleError(_context.t1);

              case 27:
                errors.register = _context.sent;
                loaders.register = LoaderStateEnum.Failed;

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 7], [15, 23]]);
      }));

      return function submit() {
        return _ref.apply(this, arguments);
      };
    }();

    return function (_ctx, _cache) {
      var _component_n_h1 = _resolveComponent("n-h1");

      var _component_n_input = _resolveComponent("n-input");

      var _component_n_form_item = _resolveComponent("n-form-item");

      var _component_n_p = _resolveComponent("n-p");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_alert = _resolveComponent("n-alert");

      var _component_n_form = _resolveComponent("n-form");

      var _component_n_hr = _resolveComponent("n-hr");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_n_h1, null, {
        default: _withCtx(function () {
          return [_hoisted_2];
        }),
        _: 1
      }), _createVNode(_component_n_form, {
        model: _unref(model),
        ref_key: "form",
        ref: form,
        rules: _unref(rules)
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_form_item, {
            path: "username",
            label: "Username"
          }, {
            default: _withCtx(function () {
              var _unref$username$find;

              return [_createVNode(_component_n_input, {
                maxlength: (_unref$username$find = _unref(rules).username.find(function (r) {
                  return !!r.max;
                })) === null || _unref$username$find === void 0 ? void 0 : _unref$username$find.max,
                "show-count": "",
                value: _unref(model).username,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(model).username = $event;
                }),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(function () {}, ["prevent"]), ["enter"]))
              }, null, 8, ["maxlength", "value"])];
            }),
            _: 1
          }), _createVNode(_component_n_form_item, {
            path: "email",
            label: "Email"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_input, {
                value: _unref(model).email,
                "onUpdate:value": _cache[2] || (_cache[2] = function ($event) {
                  return _unref(model).email = $event;
                }),
                type: "email",
                onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(function () {}, ["prevent"]), ["enter"]))
              }, null, 8, ["value"])];
            }),
            _: 1
          }), _createVNode(_component_n_form_item, {
            path: "password",
            label: "Password"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_input, {
                value: _unref(model).password,
                "onUpdate:value": _cache[4] || (_cache[4] = function ($event) {
                  return _unref(model).password = $event;
                }),
                type: "password",
                "show-password-on": "click",
                onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(function () {}, ["prevent"]), ["enter"]))
              }, null, 8, ["value"])];
            }),
            _: 1
          }), _createVNode(_component_n_p, {
            class: "mt-2 mb-4"
          }, {
            default: _withCtx(function () {
              return [_hoisted_3, _createVNode(Link, {
                to: {
                  name: 'Terms'
                },
                target: "_blank",
                classes: "text-decoration-none"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_4];
                }),
                _: 1
              }), _hoisted_5, _createVNode(Link, {
                to: {
                  name: 'Privacy'
                },
                target: "_blank",
                classes: "text-decoration-none"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_6];
                }),
                _: 1
              }), _hoisted_7];
            }),
            _: 1
          }), _unref(turnstileSiteKey) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_unref(VueTurnstile), {
            "site-key": _unref(turnstileSiteKey),
            modelValue: captcha.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
              return captcha.value = $event;
            })
          }, null, 8, ["site-key", "modelValue"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createVNode(_component_n_button, {
            type: "primary",
            size: "large",
            block: true,
            loading: _unref(loaders).register === _unref(LoaderState).Loading,
            onClick: submit
          }, {
            default: _withCtx(function () {
              return [_hoisted_10];
            }),
            _: 1
          }, 8, ["loading"])]), _unref(loaders).register === _unref(LoaderState).Failed ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 1,
            type: "error",
            class: "white-space-pre-line mt-3",
            "show-icon": false
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(errors).register), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["model", "rules"]), _createVNode(_component_n_hr, {
        class: "my-4"
      }), _createVNode(_component_n_p, null, {
        default: _withCtx(function () {
          return [_hoisted_11, _createVNode(Link, {
            to: {
              name: 'Signin',
              query: {
                to: _ctx.$route.query.to
              }
            },
            classes: "text-decoration-none"
          }, {
            default: _withCtx(function () {
              return [_hoisted_12];
            }),
            _: 1
          }, 8, ["to"])];
        }),
        _: 1
      })]);
    };
  }
});